import React, { ReactNode } from "react";
import Header from "./Header";
import "./Layout.scss";

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <>
      <Header />
      <main className="layout-main">{children}</main>
    </>
  );
};

export default Layout;
